import { useCallback, useEffect, useState } from "react";
import { listNotifications, unreadNotifications, readNotification, readAllNotifications } from "./api";

let state = { items: null, unread: 0 };
const subs = new Set();
const publish = (patch) => { state = { ...state, ...patch }; subs.forEach((f) => f(state)); };

export const refreshUnread = () => unreadNotifications().then((d) => publish({ unread: d.unread })).catch(() => {});
export const refreshNotifications = () => listNotifications().then((d) => publish({ items: d.items, unread: d.unread })).catch(() => publish({ items: state.items || [] }));
export const markNotificationRead = (n) => {
  if (n.read) return;
  readNotification(n.id).catch(() => {});
  publish({ unread: Math.max(0, state.unread - 1), items: state.items?.map((x) => (x.id === n.id ? { ...x, read: true } : x)) });
};
export const markAllNotificationsRead = () => {
  readAllNotifications().catch(() => {});
  publish({ unread: 0, items: state.items?.map((x) => ({ ...x, read: true })) });
};

export function useNotifications() {
  const [s, set] = useState(state);
  useEffect(() => { subs.add(set); return () => subs.delete(set); }, []);
  return s;
}

export function useNotificationPolling(ms = 30000) {
  const poll = useCallback(() => {
    if (document.hidden) return;
    const before = state.unread;
    refreshUnread().then(() => { if (state.items && state.unread !== before) refreshNotifications(); });
  }, []);
  useEffect(() => {
    poll();
    const t = setInterval(poll, ms);
    document.addEventListener("visibilitychange", poll);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", poll); };
  }, [poll, ms]);
}
